import { NgModule } from '@angular/core';
import { StoreModule } from '@ngrx/store';
import { backend } from '@shared/datastore/core';
import { userPendingFundsBackend } from './user-pending-funds.backend';
// import { DatastoreBackendModule } from '@shared/datastore/core';
import { userPendingFundsReducer } from './user-pending-funds.reducer';

// FIXME: remove that
backend.userPendingFunds = userPendingFundsBackend;

@NgModule({
  imports: [
    StoreModule.forFeature('userPendingFunds', userPendingFundsReducer),
    /* DatastoreBackendModule.forFeature(
      'userPendingFunds',
      userPendingFundsBackend,
    ),*/
  ],
})
export class DatastoreUserPendingFundsModule {}



// WEBPACK FOOTER //
// ./src/app/@shared/datastore/user-pending-funds/user-pending-funds.module.ts